import z from 'zod'

import { commentProperties } from './BaseModels'
import cachedDummies from './cachedDummies'
import { Group } from './Group'
import { LearningItem } from './LearningItem'
import parseModel from './parseModel'
import { dummyUser } from './User'

const baseCommentParser = z.object(commentProperties)

export type Comment = z.infer<typeof baseCommentParser> & { children: Comment[] }

// @ts-ignore
export const commentParser: z.ZodType<Comment> = baseCommentParser.extend({
  children: z.lazy(() =>
    commentParser
      .array()
      .nullish()
      .default(() => [])
  ),
})

export const dummyComment = cachedDummies(
  (uuid: string, error?: any): Comment => ({
    isDummy: true,
    error,
    uuid,

    learningItemUuid: 'dummy-1',

    userUuid: 'dummy-1',
    user: dummyUser('dummy-1'),

    parentUuid: null,
    level: 1,

    title: 'Lorem ipsum',
    text: 'Lorem ipsum dolor sit amet',

    createdAt: new Date(),
    updatedAt: new Date(),

    children: [],
  })
)

export const parseComment = parseModel<Comment>(commentParser, dummyComment)

export type CommentRootUuid = { learningItemUuid: string } | { groupUuid: string }
export type CommentRoot = LearningItem | Group
